export default __webpack_public_path__ + "imgs/23ee452e.png";